import { render, staticRenderFns } from "./SimulationTable.vue?vue&type=template&id=39bc966a&scoped=true&"
import script from "./SimulationTable.vue?vue&type=script&lang=js&"
export * from "./SimulationTable.vue?vue&type=script&lang=js&"
import style0 from "./SimulationTable.vue?vue&type=style&index=0&id=39bc966a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc966a",
  null
  
)

export default component.exports